import { render, staticRenderFns } from "./CardFile.vue?vue&type=template&id=0c1f0d8a&"
import script from "./CardFile.vue?vue&type=script&lang=js&"
export * from "./CardFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports